package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /subscriptions route — redirects to /analytics?tab=revenue.
 *
 * Content (KPIs, provider/status donuts, purchases table) has fully moved
 * to the «Выручка» tab of AnalyticsPage (R6).
 * This stub keeps old bookmarks/external links working.
 */
@Page("/subscriptions")
@Composable
fun SubscriptionsPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val period = urlParam("period")?.let { "&period=${encodeQueryValue(it)}" } ?: ""
        val status = urlParam("status")?.let { "&status=${encodeQueryValue(it)}" } ?: ""
        ctx.router.navigateTo("${Routes.ANALYTICS}?tab=revenue$period$status")
    }
}
